import { Currency } from "common/contracts";

import { DisplayPrices, Order } from "./types";

export const calculateDisplayPrices = (
    order: Order,
    currencyCodeToCurrencyMap: Map<string, Currency>
): DisplayPrices => {
    const currency = currencyCodeToCurrencyMap.get(order.currency);
    const multiplier = currency?.multiplier || 1;

    return {
        bundlePrice: order.bundlePrice / multiplier,
        amountNetTotal: order.amountNetTotal / multiplier,
        taxTotal: order.taxTotal / multiplier,
        currencyExchangeCost: order.currencyExchangeCost / multiplier,
        estimatedAppchargeFee: order.estimatedAppchargeFee != null ? order.estimatedAppchargeFee / multiplier : undefined,
        estimatedPublisherNetAmount: order.estimatedPublisherNetAmount != null ? order.estimatedPublisherNetAmount / multiplier : undefined,
        discountAmount: order.discountAmount / multiplier,
        amountNetInDollar: order.amountNetInDollar / multiplier,
        totalPrice: order.offerSnapshot.price / multiplier,
        taxAmountInDollar: order.taxAmountInDollar / multiplier,
    };
};

